import { isMobile, isTablet } from "react-device-detect";

var mult = isMobile || isTablet ? 2 : 1;

export const reel_column_1 = {
  name: "reel_column_1",
  components: [
    {
      name: "reel_1",
      type: "Sprite",
      position: { x: 55, y: 90 },
      img: "BG_Death00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_1_border",
      type: "Sprite",
      position: { x: 55, y: 90 },
      img: "major_2_frame",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_2",
      type: "AnimatedSprite",
      position: { x: 55, y: 260 },
      animation: {
        pattern: "Dragon_BG$.png",
        start: 0,
        end: 47,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_2",
      type: "Sprite",
      position: { x: 55, y: 260 },
      img: "major_4_frame",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_3",
      type: "Sprite",
      position: { x: 55, y: 450 },
      img: "a00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
  ],
};

export const reel_column_2 = {
  name: "reel_column_2",

  components: [
    {
      name: "reel_4",
      type: "Sprite",
      position: { x: 240, y: 90 },
      img: "BG_Vampire00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_4_bg",
      type: "Sprite",
      position: { x: 240, y: 90 },
      img: "major_3_frame",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_5",
      type: "AnimatedSprite",
      position: { x: 240, y: 260 },
      animation: {
        pattern: "Dragon_BG$.png",
        start: 0,
        end: 47,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_5",
      type: "Sprite",
      position: { x: 240, y: 260 },
      img: 'major_4_frame',
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_6",
      type: "Sprite",
      position: { x: 240, y: 450 },
      img: "q00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
  ],
};

export const reel_column_3 = {
  name: "reel_column_3",

  components: [
    {
      name: "reel_7",
      type: "Sprite",
      position: { x: 425, y: 95 },
      img: "j00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_8",
      type: "AnimatedSprite",
      position: { x: 420, y: 260 },
      animation: {
        pattern: "Dragon_BG$.png",
        start: 0,
        end: 47,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_8",
      type: "Sprite",
      position: { x: 420, y: 260 },
      img:'major_4_frame',
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_9",
      type: "Sprite",
      position: { x: 420, y: 450 },
      img: "q00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
  ],
};

export const reel_column_4 = {
  name: "reel_column_4",
  components: [
    {
      name: "reel_10",
      type: "Sprite",
      position: { x: 605, y: 95 },
      img: "a00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_11_icon",
      type: "AnimatedSprite",
      position: { x: 600, y: 260 },
      animation: {
        pattern: "Pump$.png",
        start: 0,
        end: 47,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_11_text",
      position: { x: 570, y: 352 },
      type: "AnimatedSprite",
      animation: {
        pattern: "wild$.png",
        start: 0,
        end: 23,
        speed: 0.5,
        loop: true,
        precision: 2,
        scale: {
          x: mult,
          y: mult,
        },
      },
    },
    {
      name: "reel_12",
      type: "Sprite",
      position: { x: 595, y: 450 },
      img: "j00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
  ],
};

export const reel_column_5 = {
  name: "reel_column_5",
  components: [
    {
      name: "reel_13",
      type: "Sprite",
      position: { x: 770, y: 90 },
      img: "BG_Candy00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_13",
      type: "Sprite",
      position: { x: 770, y: 90 },
      img: "major_5_frame",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_14",
      type: "Sprite",
      img: "k00.png",
      position: { x: 765, y: 260 },
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_15",
      type: "Sprite",
      position: { x: 767, y: 440 },
      img: "BG_Death00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_1_border",
      type: "Sprite",
      position: { x: 767, y: 440 },
      img: "major_2_frame",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
  ],
};
